import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import AgGrid from '../../shared/displayComponents/agGrid/agGrid.component';
import useReportParam from '../../shared/reports/useReportParam.hook';
import useReportData from '../../shared/reports/useReportData.hook';
import {
  ActionMenuForExport,
  useActionMenuForExport,
} from '../../shared/displayComponents/actionMenuForExport';
import ReportParamDropdown from '../../shared/reports/reportParamDropdown.component';
import checkIsFetchingAnyParam from '../../shared/reports/checkIsFetchingAnyParam';
import styles from '../../shared/reports/reportParam.module.scss';
import { taxYearSelector } from '../../shared/store/selectors';
import getReportUrl from '../shared/getReportUrl';

import columnDefinitions from './entityData.columnDefinitions';

const EntityData = ({ taxYear }) => {
  const endpointBasePath = getReportUrl('entity-data');

  const taxYearParam = useReportParam({
    endpointBasePath,
    paramName: 'taxYear',
    params: useMemo(() => ({}), []),
    defaultParamValue: taxYear,
  });

  const isFetchingAnyParam = checkIsFetchingAnyParam([taxYearParam]);

  const { reportData, isFetchingReportData, showGrid, runReportButton } = useReportData({
    endpointBasePath,
    isFetchingAnyParam,
    params: useMemo(
      () => ({
        taxYear: taxYearParam.paramValue,
      }),
      [taxYearParam.paramValue],
    ),
    fetchOnMount: true,
  });

  const { props, onGridReady } = useActionMenuForExport({ reportData });

  return (
    <>
      <div className="row">
        <div className={`col ${styles.reportParam}`}>
          <ReportParamDropdown label="Tax Year" param={taxYearParam} />
          {runReportButton}
        </div>
      </div>
      <ActionMenuForExport {...props} />
      <div className="row grid-row">
        <div className="col">
          {showGrid && (
            <AgGrid
              rowData={reportData}
              columnDefs={columnDefinitions}
              isGridLoading={isFetchingReportData}
              onGridReady={onGridReady}
            />
          )}
        </div>
      </div>
    </>
  );
};

EntityData.propTypes = {
  taxYear: PropTypes.string.isRequired,
};

export default connect(state => ({ taxYear: taxYearSelector(state) }))(EntityData);
